<template>
  <div :class="{'popup': true, 'warning': warning}" v-if="show" @click="closeBg">
    <div class="content" @click.stop>
      <div class="title">{{ title }}</div>
      <slot name='content'></slot>
      <div class="button">
        <div class="left" v-if="cancel">{{canceltext}}</div>
        <div class="right" @click.stop="confirmEvent">{{confirmtext}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			show: false
		}
	},

  props: {
    title: {
      type: String,
      default: "提示"
    },
		cancel: {
			type: Boolean,
			default: false
		},
    canceltext: {
      type: String,
      default: "取消"
		},
		
    confirmtext: {
      type: String,
      default: "我知道了"
    },
	warning: {
		type: Boolean,
		default: false
	}
	},
	
	methods: {
		open() {
			this.show = true
		},

		confirmEvent() {
			this.show = false
			this.$emit("confirm")
		},

		closeBg() {
			this.show = false
		}
	}
}
</script>

<style lang='scss' scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);

  .content {
		width: 95%;
		margin: 20% auto;
    padding: 0 10px;
    border-radius: 5px;
		overflow: hidden;
		background-color: #fff;
		
		.title {
			width: 100%;
			height: 50px;
			line-height: 50px;
			color: #009688;
			font-size: 16px;
			font-weight: bold;
			border-bottom: 2px solid #009688;
		}

		.button {
			width: 100%;
			display: flex;
			height: 50px;

			.left, .right {
				flex: 1;
				height: 50px;
				line-height: 50px;
				text-align: center;
				font-size: 16px;
				font-weight: bold;
				border-top: 2px solid #EFF2F4;
			}

			.right {
				color: #009688;
			}
		}
  }
}
.warning {
	.title {
		color: #ff4343 !important;
		border-color: #ff4343 !important;
	}
	.button {
		.right {
				color: #ff4343 !important;
			}
	}
}
</style>